import React from 'react';
import { Link } from 'gatsby';

const FloorplanNameTitle = ({ floorplanName,floorplanLink, isAv }) => {
    return (
        <Link to={ floorplanLink } className="title is-4"
            style={{ display: 'block',  color: isAv == 'Available Now' || isAv == 'Available Soon' ? '#A3B49D' : '#DBDBDB'}}
    >{floorplanName} </Link>

  );
};

export default FloorplanNameTitle;
